import cn from 'classnames';
import { ExternalReactRenderers } from '../../../components/Editor/types';
import { TipTapBaseNode } from '../../../components/Viewer/renderer';
import { DaVideoAttrs, DaVideoOptions } from '../daVideo';
import DaVideoPlayer from '../components/DaVideoPlayer';
import { useSize } from '../hooks/useSize';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';

import s from './Viewer.scss';

export interface Props {
  externalRenderers: ExternalReactRenderers;
  node: TipTapBaseNode;
}

const Viewer = ({ node }: Props) => {
  const isMounted = useIsMounted();
  const attrs = node.attrs as DaVideoAttrs;
  const config = node.extensionConfig?.daVideo as DaVideoOptions;
  const { alignment } = attrs;

  const { width, height } = useSize(
    config.defaultWidth,
    config.defaultHeight ?? 100,
    attrs.alignment,
    node.containerWidth
  );

  if (!isMounted) {
    return <div style={{ width, height }} />;
  }

  return (
    <div
      data-testid="video"
      data-da-type="da-video"
      data-src={attrs.src}
      className={cn(
        s['video-wrapper'],
        s[alignment],
        config?.smallMedia && s['small-media']
      )}
    >
      <DaVideoPlayer src={attrs.src} width={width} height={height} />
    </div>
  );
};

export default Viewer;
